export { default } from './InformationGrid';
export type { Props, Props as InformationGridProps } from './InformationGrid';
